/**
 * Человекочитаемый текст ошибки axios / Error.
 *
 * `detail` FastAPI — строкой как есть (в т.ч. 403 `{detail, code}` про 1С в
 * SSO-сессии); массив ошибок валидации (422) сворачивается в «поле — msg; …».
 * `fallback` — только когда ни `detail`, ни `message` нет.
 */
type DetailItem = { loc?: unknown[]; msg?: string; message?: string };

interface ErrorLike {
  response?: { data?: { detail?: string | DetailItem[] } };
  message?: string;
}

export function extractErrorMessage(err: unknown, fallback = "Ошибка"): string {
  const e = err as ErrorLike;
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return (
      detail
        .map((d) => {
          const field = Array.isArray(d.loc) ? d.loc.filter((x) => x !== "body").join(".") : "";
          const msg = d.msg ?? d.message ?? "";
          return field ? `${field} — ${msg}` : msg;
        })
        .filter(Boolean)
        .join("; ") || fallback
    );
  }
  return e?.message ?? fallback;
}
